<!DOCTYPE html>
<html [lang]="language">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/icofont/1.0.1/icofont.min.css">
</head>

<body [ngClass]="{'dir-rtl': language === 'ar'}">
  <app-navbar [business]="business" [menuUrl]="menuUrl" [hasMultipleBranches]="hasMultipleBranches"
    [menuBranches]="menuBranches">
  </app-navbar>
  <!-- Slider -->
  <section *ngIf="business && business.sliders && business.sliders.length > 0" class="pt-0 pb-0" id="home">
    <div class="slider-bg">
      <ul class="slides">
        <li>
          <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
            <ng-template carouselSlide *ngFor="let slide of business.sliders">
              <div class="slide-img" [style.backgroundImage]="getSliderImageUrl(slide)">
                <div class="hero-text-wrap">
                  <div class="hero-text white-color">
                    <div class="container text-center">
                      <h1 class="title raleway-font">
                        {{ (language === 'ar' && slide.description_ar) ? slide.description_ar : slide.description ||
                        languageService.getTranslation('welcomeTo') }}
                      </h1>
                      <h2 class="white-color font-700">{{ (language === 'ar' && business.name_ar) ?
                        business.name_ar : business.name }}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </li>
      </ul>
    </div>
  </section>

  <!-- Services -->
  <section *ngIf="business && getServices().length > 0" class="white-bg pb-80" id="services">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">
              {{ languageService.getTranslation('whatWeOffer') }}
            </h1>
            <h2 class="raleway-font">
              {{ languageService.getTranslation('atBusinessName', business) }}
            </h2>
          </div>
        </div>
      </div>
      <div class="row mt-50" [ngClass]="{'justify-content-center': getServices().length < 3}">
        <div *ngFor="let service of getServices()" [ngClass]="getServiceColumnClass(getServices().length)"
          class="mb-30 feature-box text-center hover-effect">
          <div class="default-bg-icon mb-20">
            <ng-container *ngIf="service.icon_url; else defaultIcon">
              <img [src]="getServiceIconUrl(service.icon_url)" alt="{{service.name}} Icon" class="service-icon">
            </ng-container>
            <ng-template #defaultIcon>
              <i class="fas fa-cogs font-30px white-color"></i>
            </ng-template>
          </div>
          <h5 class="mt-10">{{service.name}}</h5>
          <p class="font-400">{{service.description}}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- About -->
  <section *ngIf="business && (getAboutUs() || getPostalAddress() || business.social_urls?.work_hours)" class="gray-bg"
    id="about">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">
              {{ languageService.getTranslation('weAreBusinessName', business) }}
            </h1>
            <h2 class="raleway-font">
              {{ languageService.getTranslation('aboutUs') }}
            </h2>
          </div>
          <p *ngIf="getAboutUs()">{{getAboutUs()}}</p>
        </div>
      </div>
      <div class="row mt-50 justify-content-center">
        <div class="col-md-5 col-xs-12 text-center">
          <div *ngIf="getPostalAddress()" class="about-info-item mb-20">
            <h4><i class="fas fa-map-marker-alt mr-10"></i> {{getPostalAddress()}}</h4>
          </div>
          <div *ngIf="business.social_urls?.work_hours" class="about-info-item">
            <h4><i class="fas fa-clock mr-10"></i> {{business.social_urls?.work_hours}}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section
    *ngIf="business && (getPostalAddress() || business.office_numbers?.length || business.email || business.social_urls?.support_email || getSocialMediaLinks().length || business.social_urls?.deliveries?.length)"
    class="white-bg transition-none" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-md-8 centerize-col text-center">
          <div class="section-title">
            <h1 class="raleway-font default-color">
              {{ languageService.getTranslation('justKeepInTouch') }}
            </h1>
            <h2 class="raleway-font">
              {{ languageService.getTranslation('contactUsNow') }}
            </h2>
          </div>
        </div>
      </div>
      <div class="row mt-70">
        <div *ngIf="getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email"
          class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
          <div class="row mt-20">
            <div *ngIf="getPostalAddress()" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color">
                  <i class="fas fa-map-marker-alt mr-10"></i>
                  {{ languageService.getTranslation('postalAddress') }}
                </h2>
                <p class="mt-30" [ngClass]="{'text-right': language === 'ar'}">{{getPostalAddress()}}</p>
              </div>
            </div>
            <div *ngIf="business.office_numbers?.length" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color">
                  <i class="fas fa-phone-alt mr-10"></i>
                  {{ languageService.getTranslation('officeNumber') }}
                </h2>
                <p *ngFor="let number of business.office_numbers" class="mb-0 mt-30"
                  [ngClass]="{'text-right': language === 'ar'}">
                  {{number}}
                </p>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div *ngIf="business.social_urls?.support_email" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color">
                  <i class="fas fa-headset mr-10"></i>
                  {{ languageService.getTranslation('support') }}
                </h2>
                <p class="mb-0 mt-30" [ngClass]="{'text-right': language === 'ar'}">
                  {{business.social_urls?.support_email}}
                </p>
              </div>
            </div>
            <div *ngIf="business.social_urls?.deliveries?.length" class="col-md-6 col-sm-6 col-xs-12">
              <div class="section-title">
                <h2 class="raleway-font default-color">
                  <i class="fas fa-truck mr-10"></i>
                  {{ languageService.getTranslation('deliveryServices') }}
                </h2>
                <p *ngFor="let delivery of business.social_urls?.deliveries" class="mb-0 mt-30">
                  <a [href]="delivery" target="_blank" rel="noopener noreferrer"
                    class="text-yellow-600 hover:underline">
                    {{delivery}}
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-md-12 social-icons-style-01 text-center">
              <ul class="md-icon left-icon">
                <li *ngFor="let social of getSocialMediaLinks()">
                  <a [href]="social.link" target="_blank" rel="noopener noreferrer" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div [ngClass]="{
          'col-md-6 col-sm-6 col-xs-12': (getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email),
          'col-md-8 col-sm-8 col-xs-12 offset-md-2': !(getPostalAddress() || business.office_numbers?.length || business.social_urls?.support_email)
        }">
          <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
            <div class="row" [ngClass]="{'flex-row-reverse': language === 'ar'}">
              <div class="col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="visually-hidden" for="user_name">
                    {{ languageService.getTranslation('name') }}
                  </label>
                  <input type="text" minlength="2" maxlength="15"
                    [class.is-invalid]="userName.invalid && userName.touched" name="user_name" class="md-input"
                    id="user_name" [placeholder]="languageService.getTranslation('name') + ' *'"
                    [(ngModel)]="formData.user_name" #userName="ngModel" required>
                  <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                    {{ languageService.getTranslation('name') }} is required.
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="mb-3">
                  <label class="visually-hidden" for="user_email">
                    {{ languageService.getTranslation('email') }}
                  </label>
                  <input type="email" minlength="2" maxlength="35"
                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input"
                    id="user_email" [placeholder]="languageService.getTranslation('email') + ' *'"
                    [(ngModel)]="formData.user_email" #userEmail="ngModel" required email>
                  <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                    A valid {{ languageService.getTranslation('email') }} is required.
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12">
                <div class="mb-3">
                  <label class="visually-hidden" for="message">
                    {{ languageService.getTranslation('message') }}
                  </label>
                  <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                    class="md-textarea" id="message" rows="7" [placeholder]="languageService.getTranslation('message')"
                    [(ngModel)]="formData.message" #userMessage="ngModel" required
                    [ngClass]="{'text-right': language === 'ar'}"></textarea>
                  <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                    {{ languageService.getTranslation('message') }} is required.
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12">
                <div class="text-left mt-20" [ngClass]="{'text-right': language === 'ar'}">
                  <button type="submit" name="submit"
                    class="btn btn-outline btn-md btn-circle btn-animate remove-margin" [disabled]="contactForm.invalid"
                    value="Send">
                    <span>
                      {{ languageService.getTranslation('sendMessage') }}
                      <i class="ion-android-arrow-forward"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <app-footer [business]="business"></app-footer>
  <ngx-scrolltop></ngx-scrolltop>
</body>

</html>